"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindedSigner = exports._SetSignerParams = exports.protobufPackage = void 0;
/* eslint-disable */
const timestamp_1 = require("../google/protobuf/timestamp");
const minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "thesixnetwork.sixnft.nftoracle";
const base_SetSignerParams = { actor_address: "" };
exports._SetSignerParams = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actor_address !== "") {
            writer.uint32(10).string(message.actor_address);
        }
        if (message.expired_at !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expired_at), writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, base_SetSignerParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actor_address = reader.string();
                    break;
                case 2:
                    message.expired_at = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, base_SetSignerParams);
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = String(object.actor_address);
        }
        else {
            message.actor_address = "";
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = fromJsonTimestamp(object.expired_at);
        }
        else {
            message.expired_at = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actor_address !== undefined &&
            (obj.actor_address = message.actor_address);
        message.expired_at !== undefined &&
            (obj.expired_at =
                message.expired_at !== undefined
                    ? message.expired_at.toISOString()
                    : null);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, base_SetSignerParams);
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = object.actor_address;
        }
        else {
            message.actor_address = "";
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = object.expired_at;
        }
        else {
            message.expired_at = undefined;
        }
        return message;
    },
};
const baseBindedSigner = { ownerAddress: "", actorCount: 0 };
exports.BindedSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        for (const v of message.signers) {
            exports._SetSignerParams.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.actorCount !== 0) {
            writer.uint32(24).uint64(message.actorCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBindedSigner);
        message.signers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.signers.push(exports._SetSignerParams.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.actorCount = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBindedSigner);
        message.signers = [];
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signers !== undefined && object.signers !== null) {
            for (const e of object.signers) {
                message.signers.push(exports._SetSignerParams.fromJSON(e));
            }
        }
        if (object.actorCount !== undefined && object.actorCount !== null) {
            message.actorCount = Number(object.actorCount);
        }
        else {
            message.actorCount = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        if (message.signers) {
            obj.signers = message.signers.map((e) => e ? exports._SetSignerParams.toJSON(e) : undefined);
        }
        else {
            obj.signers = [];
        }
        message.actorCount !== undefined && (obj.actorCount = message.actorCount);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseBindedSigner);
        message.signers = [];
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signers !== undefined && object.signers !== null) {
            for (const e of object.signers) {
                message.signers.push(exports._SetSignerParams.fromPartial(e));
            }
        }
        if (object.actorCount !== undefined && object.actorCount !== null) {
            message.actorCount = object.actorCount;
        }
        else {
            message.actorCount = 0;
        }
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function toTimestamp(date) {
    const seconds = date.getTime() / 1000;
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
//# sourceMappingURL=binded_signer.js.map